import { render } from "./ConfigurationUpsellCart.vue?vue&type=template&id=17cc0a7b"
import script from "./ConfigurationUpsellCart.vue?vue&type=script&lang=js"
export * from "./ConfigurationUpsellCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__